import { cn } from "@/utils/cn";
import { FormField } from "@babackapp/ui/components/form";
import { Pencil2Icon } from "@radix-ui/react-icons";
import { CheckIcon } from "lucide-react";
import { useFormContext } from "react-hook-form";
import { OpeningTimesDay, StoreFormValues } from "./types";
import useTranslation from "@babackapp/translations/use-translation";
import OpeningTimesRanges from "./opening-time-ranges";
import OpeningTimesRangesForm from "./opening-time-ranges-form";

type OpeningTimesDayProps = {
  day: OpeningTimesDay;
  editing?: boolean;
  setEditing: (value: boolean) => void;
};

export default function OpeningTimesDayLine({
  day,
  editing,
  setEditing,
}: OpeningTimesDayProps) {
  const t = useTranslation();
  const { control } = useFormContext<StoreFormValues>();

  return (
    <FormField
      control={control}
      name={`openingTimes.${day}`}
      render={({ fieldState: { error } }) => (
        <div className="flex flex-col">
          <span className="text-xs font-semibold uppercase inline-flex gap-2 pt-2 items-center mb-2">
            <span className={cn(error && "text-destructive")}>
              {t(`cron.weekDays.${day}`)}
            </span>
            {error && (
              <span className="text-xs text-destructive">{error.message}</span>
            )}
            <a href="#" onClick={() => setEditing(!editing)}>
              {editing ? (
                <CheckIcon className="size-4" />
              ) : (
                <Pencil2Icon className="size-4" />
              )}
            </a>
          </span>
          {editing ? (
            <OpeningTimesRangesForm
              day={day}
              closeEditor={() => setEditing(false)}
            />
          ) : (
            <OpeningTimesRanges day={day} />
          )}
        </div>
      )}
    />
  );
}
